import {ControlPoint, Edit, MoreVert, Refresh} from "@mui/icons-material";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import React from "react";
import {Grey17, Grey6} from "../../theme/styles";
import css_self from "../Navigation/css/NavBar.module.scss";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import AdminRoleEmployeeFormApplet from "../../eoec/applet/impl/Administration/AdminRoleEmployeeFormApplet";

class AdminRoleEmployeeTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("admin-role-employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("admin-role-employee-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("admin-role-employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("admin-role-employee-form-applet-save", this.onCancelHandler);
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Employee") {
            this.setState({renderTarget: "New Employee"});
        } else if (identifier === "Disassociate Employee") {
            this.setState({renderTarget: "Disassociate Employee"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "New Employee") {
           return <AdminRoleEmployeeFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New" />;
        } else if (this.state.renderTarget === "Disassociate Employee") {
           return <AdminRoleEmployeeFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete" />;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("New Employee");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <ControlPoint sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Add Employee To Role
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Disassociate Employee"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Disassociate Employee</Typography>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(AdminRoleEmployeeTable)));